export const GROWTH_GBP_META = {
  eyebrow: 'Google Business Profile',
  titleLead: 'Profile',
  titleAccent: 'manager',
  description:
    'Posts, reviews, Q&A, and profile health — all in one place. ELVA drafts personalized responses and keeps your listing fresh, but you always have the final say.',
} as const;

export interface GbpTabDef {
  id: import('./types').GbpTabId;
  label: string;
}

export const GBP_TABS: readonly GbpTabDef[] = [
  { id: 'reviews', label: 'Review Responses' },
  { id: 'posts', label: 'Posts' },
  { id: 'qa', label: 'Q&A' },
  { id: 'profile', label: 'Profile Health' },
] as const;
